if (!customElements.get('product-tabs')) {
  customElements.define(
    'product-tabs',
    class ProductTabs extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('.product-tabs__tab'));
        this.panels = Array.from(this.querySelectorAll('.product-tabs__panel'));

        this.tabs.forEach((tab) => {
          tab.addEventListener('click', () => this.selectTab(tab));
        });
      }

      selectTab(selectedTab) {
        this.tabs.forEach((tab) => {
          const isSelected = tab === selectedTab;
          tab.classList.toggle('active', isSelected);
          tab.setAttribute('aria-selected', isSelected ? 'true' : 'false');
        });

        this.panels.forEach((panel) => {
          panel.classList.toggle('active', panel.id === selectedTab.getAttribute('aria-controls'));
        });
      }
    }
  );
}
